import React from 'react';

import { registerDecoration } from 'core/forms';

import { Typo } from 'uikit/content';

import styles from '../styles/formDecorationText.module.scss';

const FormDecorationText = ({ schema: { text } }) => (
  <Typo className={styles.element} color="secondary" variant="s01">
    {text}
  </Typo>
);

registerDecoration('Text', React.memo(FormDecorationText));

export default FormDecorationText;
